import { render, staticRenderFns } from "./CompBookStep4.vue?vue&type=template&id=dc1dc7ba&scoped=true"
import script from "./CompBookStep4.vue?vue&type=script&setup=true&lang=js"
export * from "./CompBookStep4.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1dc7ba",
  null
  
)

export default component.exports